import React, { useCallback } from "react";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";
import FnrTypography from "FnrTypography";

import FnrButton3 from "UI/FnrButton3";
import { colors } from "UI/colors";

import { parseButtonFunc } from "Utilities/parseButtonFunc";

import { buttonFuncConfig } from "../../componentsConfig";

const Button = () => {
  const {
    buttonText,
    buttonFunc,
    customizations: { buttonColor = colors.fnBlue } = {},
  } = useCategoryCardContext();

  const [funcKey, param] = parseButtonFunc(buttonFunc);

  const handleClick = useCallback(() => {
    if (buttonFuncConfig[funcKey]) return buttonFuncConfig[funcKey](param);
    return () =>
      console.log(`${funcKey} is not a function in buttonFuncConfig`);
  }, [funcKey, param]);

  if (!buttonText || !buttonFunc) return null;
  return (
    <FnrButton3
      data-cy={buttonFunc}
      color={buttonColor ? buttonColor : colors.fnBlue}
      size="small"
      fullWidth
      onClick={handleClick}
    >
      <FnrTypography type="copy" bold fontSize="md" color="textLight">
        {buttonText}
      </FnrTypography>
    </FnrButton3>
  );
};

export default Button;
